// Detect if we're running on production domain
const isProductionDomain = typeof window !== 'undefined' && 
  (window.location.hostname === 'www.explanatum.co.uk' || 
   window.location.hostname === 'explanatum.co.uk');

// Determine API URL
const runtimeApiUrl = (() => {
  // ALWAYS use production API if on production domain
  if (isProductionDomain) {
    return 'https://api.explanatum.co.uk';
  }

  // Use environment variable if set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.trim();
  }

  // Default to localhost for development
  return 'http://localhost:5000';
})();

const runtimeNodeEnv = process.env.NODE_ENV || 'development';

export const ENV = {
  API_URL: runtimeApiUrl,
  API_TIMEOUT: 30000,
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
  NODE_ENV: runtimeNodeEnv
};

export default ENV;
